import { OverlayProvider } from '@react-aria/overlays';
import * as React from 'react';
import { ThemeProvider } from 'styled-components';
export const FabricProvider = ({ theme, children }) => {
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(OverlayProvider, null, children)));
};
